/* src/app/shared-module/components/no-data-found/no-data-found.component.scss */
.no-property-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  text-align: center;
  padding: 24px 0;
}
.no-property-animation {
  position: relative;
  margin-bottom: 14px;
}
.floating-key {
  position: absolute;
  left: 60px;
  top: 10px;
  animation: float-key 2s ease-in-out infinite alternate;
}
@keyframes float-key {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-12px);
  }
}
.no-property-text {
  font-size: 1.2em;
  color: #1976d2;
  font-weight: 600;
  margin-top: 10px;
  letter-spacing: 0.5px;
}
.no-property-subtext {
  font-size: 0.98em;
  color: #888;
  margin-top: 4px;
}
/*# sourceMappingURL=no-data-found.component.css.map */
